import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IShop } from '../interfaces';
import { ShopMapper } from '../mappers';

export type IGetShopsRepoResponse = IRepoResponse<200, { data: IShop[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetShopsRepo = IRepo<[any], IGetShopsRepoResponse>;

export const GetShopsRepoType = Symbol.for('GetShopsRepo');

@bind(GetShopsRepoType)
export class GetShopsRepo implements IGetShopsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/client/shop', query) });

      if (result.status === 200) {
        const data: IShop[] = ShopMapper.toDomain(result.data.data);
        const total: number = result.data.total;
        return {
          status: 200 as 200,
          response: { data, total },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
